import axios from "axios";
import processResponse from "./processResponse";
import config from "../../../config";

export class EvaMsg {
    constructor({ text, code, context }) {
        this.text = text;
        this.code = code;
        this.context = context;
    }
}

class Eva4Connection {

    constructor() {
        this.sessionCode = "";
        this.eva4Config = config.eva4Config;
        this.userRef = Math.floor(Math.random() * 1000000000000000000 + 1);
        this.evaToken = "";
        this.url = "";
    }

    sendInitialMessage = () => {
        return new Promise((resolve, reject) => {
            this.sendMessage(null, '%EVA_WELCOME_MSG', {
                lang: 'es',
                session: ''
            })
                .then(({ messages, sessionCode }) => {
                    resolve({ messages, sessionCode })
                })
                .catch(err => reject(err));
        })
    }

    sendMMBInitialMessage = () => {
        return new Promise((resolve, reject) => {
            this.sendMessage('%EVA_MMBWELCOME_MSG', null, {
                lang: 'es',
                session: ''
            })
                .then(({ messages, sessionCode }) => {
                    resolve({ messages, sessionCode })
                })
                .catch(err => reject(err));
        })
    }

    getEvaToken = () => {
        return new Promise((resolve, reject) => {

            const msg = {
                grant_type: this.eva4Config.token.grant_type,
                client_id: this.eva4Config.token.client_id,
                client_secret: this.eva4Config.token.client_secret,
            };

            const msgEnconded = new URLSearchParams(msg).toString();

            axios
                .post(
                    `${this.eva4Config.token.keycloak_url}${this.eva4Config.token.org_name}/protocol/openid-connect/token`,
                    msgEnconded
                )
                .then((response) => {
                    const token = response.data.access_token;
                    return resolve(token);
                })
                .catch((err) => reject(err));
        });
    };

    sendMessage = async (text, code, options) => {

        if (!this.evaToken) {
            this.evaToken = await this.getEvaToken();
        }

        return new Promise((resolve, reject) => {
            if (options && options.context && options.context.checking) {
                options.checking = options.context.checking;
            }
            const msg = new EvaMsg({
                text: text || "",
                code: code || "",
                context: options
            });

            if (window.sessionStorage.getItem('accessToken') != null) {
                options.accessToken = window.sessionStorage.getItem('accessToken');
            } else {
                options.accessToken = ""
            }

            if (window.sessionStorage.getItem('qm_last_page') != null) {
                options.qm_last_page = window.sessionStorage.getItem('qm_last_page');
            } else {
                options.qm_last_page = ""
            }

            if (window.sessionStorage.getItem('retrieveMemberDetailV2') != null) {
                options.retrieveMemberDetailV2 = window.sessionStorage.getItem('retrieveMemberDetailV2');
            } else {
                options.retrieveMemberDetailV2 = {}
            }

            if (window.sessionStorage.getItem('ib-MmB-app.bookingsList') != null) {
                options.bookingsList = window.sessionStorage.getItem('ib-MmB-app.bookingsList');
            } else {
                options.bookingsList = []
            }

            if (window.sessionStorage.getItem('customerData') != null) {
                options.customerData = window.sessionStorage.getItem('customerData');
            } else {
                options.customerData = {}
            }

            if (window.sessionStorage.getItem('ib-MmB-app.PNR') != null) {
                options.mmbPNR = window.sessionStorage.getItem('ib-MmB-app.PNR');
            } else {
                options.mmbPNR = {}
            }

            if (window.sessionStorage.getItem('ib-MmB-app.checkinSurname') != null) {
                options.mmbSurname = window.sessionStorage.getItem('ib-MmB-app.checkinSurname');
            } else {
                options.mmbSurname = {}
            }

            const instance = this.eva4Config.conversation.url.instance;
            const org = this.eva4Config.conversation.url.orgUUID;
            const env = this.eva4Config.conversation.url.envUUID;
            const bot = this.eva4Config.conversation.url.botUUID;
            const channel = this.eva4Config.conversation.url.channelUUID;
            const sessionCode = options ? options.session : this.sessionCode;
            const headers = this.eva4Config.conversation.headers;
            headers["USER-REF"] = this.userRef;
            headers["Authorization"] = "Bearer " + this.evaToken;

            axios
                .post(
                    `https://api-${instance}.eva.bot/eva-broker/org/${org}/env/${env}/bot/${bot}/channel/${channel}/v1/conversations/${sessionCode}`,
                    msg,
                    { headers: headers }
                )
                .then((response) => {
                    const { messages, context, sessionCode, liveAgent } = processResponse(response);
                    this.context = context;
                    this.sessionCode = sessionCode;
                    return resolve({ messages, context, sessionCode, liveAgent });
                })
                .catch((err) => {
                    if (err.response && err.response.status === 401) {
                        this.evaToken = "";
                        return resolve(this.sendMessage(text, code, options));
                    }
                    return resolve();
                });
        });
    };
}

export default Eva4Connection;
